export const websites = [
    {
        url: 'http://www.digicult-verbund.de/',
        img: require('../../assets/buttons/digicult.png')
    },
    {
        url: 'http://museen-nord.de/',
        img: require('../../assets/buttons/museen-nord.png')
    },
    {
        url: 'http://saarland.digicult-museen.net/',
        img: require('../../assets/buttons/saarland.png')
    },
    {
        url: 'http://museumsverband-shhh.de/',
        img: require('../../assets/buttons/mvshhh.png')
    },
    {
        url: 'https://sammlungonline.mkg-hamburg.de/',
        img: require('../../assets/buttons/mkg.png')
    },
    {
        url: 'http://rheinische-geschichte.lvr.de/',
        img: require('../../assets/buttons/rheinische_geschichte.png')
    },
    {
        url: 'https://alltagskulturen.lvr.de/',
        img: require('../../assets/buttons/alltagskulturen.png')
    },
    {
        url: 'http://rheinische-museen.lvr.de/',
        img: require('../../assets/buttons/rheinische_museen.png')
    },
    {
        url: 'http://www.museen.thueringen.de/',
        img: require('../../assets/buttons/museen-th.png')
    },
    {
        url: 'http://sammlungen.uni-jena.de/',
        img: require('../../assets/buttons/sammlung-uni-jena.png')
    },
    {
        url: 'https://camburg-museum.de/objekte.html',
        img: require('../../assets/buttons/camburg.png')
    },
    {
        url: 'http://pinnebergmuseum.de/',
        img: require('../../assets/buttons/pm_web_logo_13.png')
    },
    {
        url: 'https://www.deutsche-digitale-bibliothek.de/searchresults?query=&offset=0&rows=20&facetValues[]=provider_fct%3DdigiCULT-Verbund+eG&isThumbnailFiltered=false',
        img: require('../../assets/buttons/ddb.png')
    },
    {
        url: 'https://www.europeana.eu/portal/de',
        img: require('../../assets/buttons/europeana.png')
    }
]



// WEBPACK FOOTER //
// ./src/components/configs/websites.js